// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ZFyto","title":"Header_title__1KdEp","side":"Header_side__141g6"};